import api from '@/common/api/index';
import { makeResponse } from '@/common/api/utils';


// eslint-disable-next-line import/prefer-default-export,no-return-await
export const fetchUser = async () => (makeResponse(await api.get('users/current/')));
